import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, SectionDivider } from './Icons';
export const TestimonialsSection = () => {
  const testimonials = [{
    name: 'Elena R.',
    age: '48 años',
    quote: 'Pasé de despertarme 4 veces por noche y no poder abrocharme mis jeans favoritos, a dormir 7 horas seguidas y sentirme ligera de nuevo. Lo mejor es que no paso hambre. Entender mis hormonas fue la pieza del puzzle que me faltaba.',
    result: 'Vientre desinflamado en 21 días.'
  }, {
    name: 'Marta G.',
    age: '52 años',
    quote: "Como profesional, la neblina mental me aterraba. Pensé que estaba perdiendo mis facultades. Con el protocolo 'Focus Laser' recuperé mi nitidez mental en la primera semana. Es increíble lo que sucede cuando dejas de castigar a tu cuerpo.",
    result: 'Adiós neblina mental y fatiga.'
  }];
  return <section className="py-8 px-4 md:px-8 bg-brand-creamAlt" data-id="element-190">
      <div className="max-w-5xl mx-auto" data-id="element-191">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-192">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-charcoal" data-id="element-193">
            Historias Reales. Resultados Reales.
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-194">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-white p-8 rounded-2xl shadow-md border-t-4 border-brand-green relative" data-id="element-195">
              <div className="flex gap-1 text-brand-gold mb-6" data-id="element-196">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5" data-id="element-197" />)}
              </div>

              <p className="text-lg text-brand-charcoal/80 italic mb-8 relative z-10" data-id="element-198">
                "{t.quote}"
              </p>

              <div className="mt-auto pt-6 border-t border-brand-creamAlt" data-id="element-199">
                <div className="flex justify-between items-end" data-id="element-200">
                  <div data-id="element-201">
                    <p className="font-bold text-brand-charcoal" data-id="element-202">{t.name}</p>
                    <p className="text-sm text-brand-charcoal/60" data-id="element-203">{t.age}</p>
                  </div>
                  <div className="bg-brand-cream px-3 py-1 rounded-full border border-brand-green/20" data-id="element-204">
                    <p className="text-xs font-bold text-brand-green uppercase tracking-wider" data-id="element-205">
                      Resultado: {t.result}
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>

        <SectionDivider data-id="element-206" />
      </div>
    </section>;
};